module.exports = __webpack_public_path__ + "static/media/phone.c3fd080c.svg";